import { Component, OnInit } from '@angular/core';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { AuthenticationService } from '../../services/authentication.service';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { environment } from '../../../environments/environment';

const oAuthConfig: AuthConfig = {
    issuer: environment.googleCredentials.issuer,
    strictDiscoveryDocumentValidation: environment.googleCredentials.strictDiscoveryDocumentValidation,
    redirectUri: environment.googleCredentials.redirectUri,
    clientId: environment.googleCredentials.clientId,
    scope: environment.googleCredentials.scope
}

@Component({
    selector: 'app-google-response',
    templateUrl: './google-response.component.html',
    styleUrls: ['./google-response.component.scss']
})
export class GoogleResponseComponent implements OnInit {

    show_invalid_message: boolean = false;
    show_loading: boolean = true;
    constructor(private readonly oAuthService: OAuthService, private route: ActivatedRoute,
        private router: Router, private authentication: AuthenticationService) {
        oAuthService.configure(oAuthConfig);

        this.oAuthService.loadDiscoveryDocument().then(
            () => {
                this.oAuthService.tryLoginImplicitFlow().then(
                    () => {
                        if (!this.oAuthService.hasValidAccessToken()) {
                            this.show_invalid_message = true;
                            this.show_loading = false;
                        }
                        else {
                            debugger;
                            this.oAuthService.loadUserProfile().then(
                                (userProfile: any) => {
                                    debugger;
                                    console.log("google user profile", userProfile);
                                    this.getGoogleUserData(userProfile.info);
                                }
                            );
                        }
                    }
                );
            }
        );

    }
    getUserIpLocation() {
        this.authentication.getUserIpLocation().subscribe(
            (res: any) => {
                //TODO: Check the output of the service - the below line
                //this.rootScope.userAddress = res;
                console.log(res);
            },
            (err: any) => {
                console.error("getUserIpLocation", err);
            })
    }
    login(userData: any) {

        //generate token

        let authorizationData: any = {
            id: userData.id,
            token: '',
            userName: userData.eMail,
            refreshToken: "",
            useRefreshTokens: false,
            isAuth: true,
            mobileNumber: userData.mobilePhone
        };

        this.authentication._setLocalStorage("authorizationUserData", JSON.stringify(userData));
        this.authentication._setLocalStorage("authorizationData", JSON.stringify(authorizationData));
        this.authentication._authentication = authorizationData;
        this.authentication.userData = userData;

        //TODO: Pass the user ID
        //this.authenticationService._addUserLogin();

        this.getUserIpLocation();

        var returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
        if (returnUrl != "/")
            this.router.navigate([returnUrl]);
        else {
            //this.router.navigate(['../profile/news-feed']);
            this.router.navigate(['/home/news-feed']);
        }

    }
    getGoogleUserData(userProfile: any) {
        debugger;
        let obj: any = {
            "name": userProfile.name,
            "emailAddress": userProfile.email
        }
        this.authentication.getGoogleUserData(obj).subscribe(
            (res: any) => {
                if (res.success) {
                    if (res.data.userType == "registered") {
                        this.login(res.data.user);
                    }
                    else {
                        this.authentication._loginData.loginType = "google";
                        this.authentication._loginData.email = res.data.emailAddress;
                        this.authentication._loginData.userType = res.data.userType;
                        this.authentication._loginData.firstName = res.data.firstName;
                        this.authentication._loginData.lastName = res.data.lastName;

                        this.router.navigate(['/auth/register']);
                    }
                }
                else {
                    this.show_loading = false;
                    this.show_invalid_message = true;
                }

            },
            (err: any) => {
                console.error("getGoogleProfileData err", err);
                this.show_loading = false;
                this.show_invalid_message = true;
            }
        );
    }
    ngOnInit(): void {
    }

}
